import { Client, Account, Databases, Storage, ID } from "appwrite";

const client = new Client();
client.setProject("683db31800179a0cd4d6");

const account = new Account(client);
const database = new Databases(client);
const storage = new Storage(client);

export { account, client, database, storage, ID };
